import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';
import config from '@/Framework/config';

export const getAboutPageMetaSchema = () => ({
  '@context': 'https://schema.org/',
  '@type': 'AboutPage',
  url: finsightWebUrl.getAboutUrl(),
  name: 'About Us',
  text: `FINSIGHT creates high-reliability financial technology that provides unparalleled visibility with actionable
  insights into capital markets. We are a New York City-based company serving thousands of the leading institutional
  investors, investment banks and corporations across the globe.
  Trusted by the world's leading financial institutions.

  Our applications streamline workflows that facilitate hundreds of billions of dollars worth of capital markets activity.

  Providing world-class fanatical 24x7 support
  We offer unlimited, 24x7x365 U.S. based phone, email and live-chat support to all stakeholders utilizing our services.
  We don't ask for testimonials. Below is unsolicited feedback we've received from clients.

  An award winning technology platform
  In an industry poll coordinated by Euromoney's Global Capital, our company won the U.S. securitization data and
  technology provider of the year awards two years in a row. We are aiming for a third.

  How can we help?
  We are driven to solve meaningful problems in the institutional capital markets space and have a great track record of doing so.
  If your company has unique challenges you wish us to explore, please get in touch.`,
  about: {
    '@type': 'Organization',
    name: 'Finsight',
    url: finsightWebUrl.getUrl(),
    telephone: config.tenant.finsight.supportPhoneNumber,
    email: config.tenant.finsight.supportEmail,
    award: ['2019 GlobalCapital Securitization Award Winner', '2018 GlobalCapital Securitization Award Winner']
  }
});

export const getSolutionPageMetaSchema = () => ({
  '@context': 'https://schema.org/',
  '@type': 'Organization',
  name: 'Finsight',
  url: finsightWebUrl.getOurProductsUrl(),
  telephone: config.tenant.finsight.supportPhoneNumber,
  email: config.tenant.finsight.supportEmail,
  makesOffer: {
    '@type': 'Offer',
    itemOffered: [
      {
        '@type': 'Service',
        name: 'Deal Roadshow',
        description: 'Industry-leading digital roadshow platform used to market deal and non-deal roadshows for equity, debt, municipal and private placement offerings. Great investor experience; streamlined underwriter workflows; unparalleled insight into the syndication process.',
        url: 'https://dealroadshow.finsight.com/'
      },
      {
        '@type': 'Service',
        name: 'DealVDR',
        description: 'An intuitive, lightning fast, secure virtual data room. DealVDR offers robust permissioning, drag & drop uploading, unlimited users & pages, and 24x7 fanatical support. Flexible 90-day (free) setup period and a 20% savings guarantee over other VDRs.',
        url: 'https://dealvdr.com/'
      },
      {
        '@type': 'DataCatalog',
        name: 'Finsight.com',
        description: 'FREE new issue deal database and search engine for global fixed income securities across ABS, IG and HY corporates. Browse by region, industry, sector, sponsor, and issuer. Highly accessible (mobile friendly) and intuitively organized.',
        url: finsightWebUrl.getUrl()
      },
      {
        '@type': 'DataCatalog',
        name: 'InvestorSet',
        description: 'InvestorSet is a document library for corporates to streamline investor access to deal documentation and periodic reporting - improving liquidity in secondary markets. It’s secure, cost effective and backed by fanatical 24x7 support.',
        url: 'https://investorset.com/'
      },
      {
        '@type': 'Service',
        name: '17g5.com',
        description: "The leading data room for SEC Rule 17g-5 compliance. It's cost effective and easy to manage with email and audio uploading. Using another provider? We guarantee thousands of dollars in savings and offer fast migration services free of charge.",
        url: 'https://17g5.com/'
      }
    ]
  }
});

export const getContactUsPageMetaSchema = () => ({
  '@context': 'https://schema.org/',
  '@type': 'ContactPage',
  url: finsightWebUrl.getContactUsUrl(),
  name: 'Contact Us',
  description: 'Send us your questions or comments through this page or contact our fanatical 24x7 support via phone or email.',
  mainEntity: {
    '@type': 'Organization',
    name: 'Finsight',
    url: finsightWebUrl.getUrl(),
    telephone: config.tenant.finsight.supportPhoneNumber,
    email: config.tenant.finsight.supportEmail,
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: config.tenant.finsight.supportPhoneNumber,
        contactType: 'customer service',
        areaServed: 'United States & Canada'
      },
      {
        '@type': 'ContactPoint',
        telephone: '+852 3018-1600',
        contactType: 'customer service',
        areaServed: 'Asia Pacific'
      },
      {
        '@type': 'ContactPoint',
        telephone: '+44 808-178-7364',
        contactType: 'customer service',
        areaServed: 'Europe, Middle East & Africa'
      },
      {
        '@type': 'ContactPoint',
        telephone: '+55 21-3958-8827',
        contactType: 'customer service',
        areaServed: 'Latin America'
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Deal Roadshow',
        email: config.tenant.dealroadshow.supportEmail
      },
      {
        '@type': 'ContactPoint',
        contactType: 'DealVDR',
        email: config.tenant.tenantDealvdr.supportEmail
      },
      {
        '@type': 'ContactPoint',
        contactType: '17g5.com',
        email: config.tenant.tenant17g5.supportEmail
      },
      {
        '@type': 'ContactPoint',
        contactType: 'InvestorSet',
        email: config.tenant.tenantInvestorSet.supportEmail
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Sales',
        email: 'sales@finsight.com'
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Legal',
        email: 'legal@finsight.com'
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Billing',
        email: 'billing@finsight.com'
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Careers',
        email: 'careers@finsight.com'
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Media',
        email: 'legal@finsight.com'
      }
    ]
  }
});

export const getCareersPageMetaSchema = () => ({
  '@context': 'https://schema.org/',
  '@type': 'CareersPage',
  url: finsightWebUrl.getCareersUrl(),
  name: 'Careers',
  description: "We're looking for creative, self-motivated people who value an entrepreneurial environment and are committed to excellence. Explore our open positions here.",
  mainEntity: {
    '@type': 'OpenPositions',
    name: 'Finsight',
    url: finsightWebUrl.getUrl(),
    telephone: config.tenant.finsight.supportPhoneNumber,
    email: config.tenant.finsight.supportEmail,
    jobPosting: [
      {
        '@type': 'jobPosting',
        title: 'PHP Software Engineer',
        occupationalCategory: 'Development',
        description: 'We are looking for a strong PHP Software Engineer to join our team in Kyiv. You will be an integral member of a development team that is focused on building new business functionality, in order to solve problems that are meaningful to our customers. You will have an opportunity to work with top notch technologies, as well as with a team of real professionals.',
        responsibilities: [
          'Research and evaluate technical options to implement business requirements.',
          'Analyze and estimate implementation efforts.',
          'Write quality, maintainable code.',
          'Implement new functionality and support existing code.'
        ],
        qualifications: [
          '4+ years of commercial development',
          'High level of responsibility',
          'Strong attention to detail',
          'Collaborative and flexible team player',
          'Excellent communication and time management skills',
          'PHP 7+, SOLID, OOP',
          'Knowledge of design patterns and best practices (clean/onion/hexagonal (layers), SOA)',
          'Microservices, СQRS, DDD knowledge is preferred (message queue / bus, JSON-RPC/grpc protocols )',
          'Databases (MySQL 5.6+, Postgres) - all types of joins, basic knowledge of groupings and window functions, OVER clause, transactions, understanding of indices (balanced tree)',
          'Containerization (docker or kubernetes)'
        ],
        benefits: [
          '15-days of paid vacation + 5-days of sick leave',
          'Flexible schedule',
          'Beautiful office in center of Kiev',
          'English classes',
          'Fully stocked snack room'
        ],
        employmentType: 'Full-time',
        datePosted: '2020-03-01',
        hiringOrganization: {
          '@type': 'Organization',
          name: 'Finsight',
          url: finsightWebUrl.getCareersUrl()
        },
        jobLocation: {
          '@type': 'Place',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Kyiv',
            addressRegion: 'Ukraine',
            addressCountry: 'Ukraine'
          }
        }
      },
      {
        '@type': 'jobPosting',
        title: 'Sales Associate (Junior)',
        occupationalCategory: 'Sales',
        description: 'The Sales Associate position is highly focused on new business development, specifically finding and organizing new meetings for Finsight’s senior sales team. This is an exciting opportunity to join an innovative firm where you can make an immediate impact and develop critical career skills. You will work closely with senior sales and executive management teams and will report to a senior sales director.',
        responsibilities: [
          'New Business Development: Identify and qualify prospects with the goal of scheduling meetings and calls with key stakeholders.',
          'Support senior sales members in managing their pipeline development from introduction to close.',
          'Tasks may include: developing targeted prospects lists, cold calling, email correspondence, and managing follow up cadence.',
          'Attend, participate and eventually lead client pitches and meetings with the objective of developing new business or fostering meaningful client relationships.',
          'Mastery of our products, services and understanding of use cases based on client type.'
        ],
        qualifications: [
          'Experience: 0-1 Year',
          'Client focused mentality',
          'Highly self-motivated, organized and goal orientated',
          'Strong attention to detail',
          'Excellent written and verbal communication',
          'Ability to work independently',
          'Team player that prioritizes the best interest of the company and its employees',
          'Ability to see tasks and projects through to conclusion',
          'Organized, with an ability to prioritize time-sensitive assignments',
          'Proficient in Microsoft Office Suite',
          'The ability to build and maintain strong client relationships'
        ],
        benefits: [
          '15-days of paid vacation + 5-days of sick leave',
          'Comprehensive medical, dental, vision & life insurance',
          'Fully stocked snack room'
        ],
        employmentType: 'Full-time',
        datePosted: '2020-03-01',
        hiringOrganization: {
          '@type': 'Organization',
          name: 'Finsight',
          url: finsightWebUrl.getCareersUrl()
        },
        jobLocation: {
          '@type': 'Place',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'New York City',
            addressRegion: 'New York',
            addressCountry: 'United States'
          }
        }
      }
    ]
  }
});
